import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/src/popokgamingv2-prd/components/Layout/Footer/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/src/popokgamingv2-prd/components/Layout/Header/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/src/popokgamingv2-prd/components/Loading/InitialLoadSuspense.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/src/popokgamingv2-prd/components/popups/DisclaimerModal/index.tsx");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/ar.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/en.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/es.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/fr.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/hi.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/pt.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/ru.png");
;
import(/* webpackMode: "eager" */ "/var/src/popokgamingv2-prd/public/assets/Images/flags/zh.png");
